import { Box, styled, Typography } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';

export const StyledImage = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
`;

export const StyledThumbImage = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 7px;
`;

export const ViewLargeImageTypography = styled(Typography)`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #0f1111;
  display: flex;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
`;

export const ThumbSlideContainer = styled(Box)`
  width: 100%;
  padding: 0;
  overflow: auto;
  min-height: 74px;
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 8px;
`;

export const StyledThumbSwiperSlide = styled(SwiperSlide)`
  border: 1px solid #d1d1d1;
  border-radius: 8px;
  height: 70px;
`;

export const StyledSwiper = styled(Swiper)`
  width: 100%;
  height: 100%;
  overflow: hidden;
  max-height: 500px;

  & .swiper-button-next {
    width: 40px;
    height: 40px;
    background-color: #fff;
    border-radius: 100px;
    opacity: 0.4;
  }

  & .swiper-button-prev {
    width: 40px;
    height: 40px;
    background-color: #fff;
    border-radius: 100px;
    opacity: 0.4;
  }

  & .swiper-button-prev::after,
  & .swiper-button-next::after {
    display: none;
  }
`;

export const StyledStackThumbSwiper = styled(Swiper)`
  width: 100%;
  height: 100%;
  overflow: auto;
  & .swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    max-height:calc(100vh - 724px);
    height: auto;
    & .swiper-slide {
      margin: 0;
      max-width: 190px;
      height: 129px;
    }
  }
  & .swiper-button-next {
    right: -8px;
  }

  & .swiper-button-prev {
    left: -8px;
  }

  & .swiper-button-prev::after,
  & .swiper-button-next::after {
    display: none;
  }
`;

export const StyledImageContainer = styled(Box)`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  height: 100%;
`;
